import { parseStringPromise } from "xml2js";

export class ESocialXmlReaderService {
    async transformXmlToJs(xmlData, fileName) {
        const xmlObject = await parseStringPromise(xmlData);

        const eventObjectPath =
            "eSocial.retornoProcessamentoDownload[0].evento[0].eSocial[0]";

        let eSocialEvent = xmlObject;
        for (const key of eventObjectPath.split(".")) {
            if (key.endsWith("]")) {
                const [keyName, index] = key.split(/[[\]]/);
                eSocialEvent = eSocialEvent[keyName][index];
            } else {
                eSocialEvent = eSocialEvent[key];
            }
        }

        const eventType = Object.keys(eSocialEvent).find((key) =>
            key.startsWith("evt")
        );
        if (!eventType) throw new Error("tipo do evento não identificado");

        const eventData = eSocialEvent[eventType][0];
        const eventId = eventData.$.Id;
        // const [_, eventId] = eventData.$.Id.toLowerCase().split('id')
        delete eventData.$;

        return {
            eventType,
            eventData: {
                eventId,
                ...eventData
            },
            fileName
        };
    }
}
